module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_39.69ba7240.jpg";